import { defineMessages } from '@transcend-io/internationalization';

export const takeControlMessages = defineMessages(
  'privacy-center.containers.TakeControl.takeControl',
  {
    takeControl: {
      defaultMessage: 'Make a Privacy Request',
      description:
        'The message to display on the button to submit privacy requests.',
    },
    viewPastRequests: {
      defaultMessage: 'View Past Requests',
      description:
        'The message to display on the button to view past privacy requests.',
    },
    title: {
      defaultMessage: 'You have the controls to manage your privacy',
      description:
        'The message to display in the privacy center modal when the user is choosing the request type to submit.',
    },
    header: {
      defaultMessage: 'I would like to:',
      description:
        'The message to display on top of the Privacy Request type selection buttons.',
    },
    dataSubjectLoggedIn: {
      defaultMessage: 'Verified as a {dataSubject}',
    },
    partitionLoggedIn: {
      defaultMessage: 'Selected category: {partition}',
    },
    dataSubjectNotLoggedIn: {
      defaultMessage:
        'Already submitted a request? {verifyIdentityLogin} to check its status.',
    },
    dataSubjectSelectLabel: {
      defaultMessage: 'Select data subject type',
    },
    noDescription: {
      defaultMessage: 'No description provided',
    },
  },
);
